import { useNavigationType } from 'react-router-dom';
import { Action } from '@remix-run/router';

import CalendarEventDetails from '@/modules/calendar/components/data-calendar/details/calendar-event-details';
import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { Article, ArticleModal } from '@/modules/articles/export';
import {
  useWidgetNavigate,
  useWidgetLoaderData,
  useWidgetSearchParams,
  LocalWidgetRouterContext,
  LocalWidgetRouterState,
} from '@/core/widgets/export';
import { useContext, useState } from 'react';

export default function EventPage() {
  const navigate = useWidgetNavigate();
  const event = useWidgetLoaderData();
  const navigationType = useNavigationType();
  const [articleId, setArticleId] = useState<string>();
  const { basePath } = useContext<LocalWidgetRouterState>(LocalWidgetRouterContext);
  const isSingleCalendar = basePath.startsWith('/events/');

  const searchParams = useWidgetSearchParams();
  const view = searchParams.get('view');
  const date = searchParams.get('date');

  return (
    <>
      <CalendarEventDetails
        key={(event as NewsEvent)?.id}
        newsEvent={event as NewsEvent}
        onClose={() => {
          if (navigationType === Action.Push) {
            navigate(-1);
          } else {
            if (isSingleCalendar) {
              navigate('/');
            } else {
              const targetView = view || 'daily';
              const targetDate = date || (event as NewsEvent)?.date || 'today';
              navigate(`/${targetView}/${targetDate}`);
            }
          }
        }}
        onArticleClick={(article: Article) => setArticleId(article.uri)}
      />
      <ArticleModal onClose={() => setArticleId(undefined)} articleId={articleId} />
    </>
  );
}
